<template>
  <el-dialog
    title="编辑管理员"
    :visible.sync="outerVisible"
    width="500px"
    @close="offDialog"
    style="text-align:left;"
  >
    <el-form ref="forms" :model="form" label-width="100px" label-position="left">
      <el-form-item label="管理员手机号" prop="mobile" :rules="rules">
        <el-col :xs="24" :sm="24" :md="24" :lg="20">
          <el-input
            class="phone_input"
            :disabled="true"
            v-model="form.mobile"
            placeholder="请输入要添加的管理员手机号"
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="用户名称" prop="name">
        <el-col :xs="24" :sm="24" :md="24" :lg="20">
          <el-input class="phone_input" :disabled="true" v-model="form.name" placeholder="请输入用户名称"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="角色" prop="roleName">
        <el-col :xs="24" :sm="24" :md="24" :lg="20">
          <el-select v-model="form.roleId" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId"
            ></el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="IP白名单" prop="limit">
        <el-radio-group v-model="form.limit">
          <el-radio label="不启用"></el-radio>
          <el-radio label="启用"></el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="outerVisible = false">取 消</el-button>
      <el-button type="primary" @click="commitset">保存</el-button>
    </div>
    <div class="iplist_box" v-show="form.limit == '启用'">
      <div class="iplist_titile">
        <el-button
          icon="el-icon-plus"
          size="mini"
          @click="addIp"
          circle
          style="padding:4px;margin-top:4px;margin-right:5px"
        ></el-button>
        <span>IP白名单列表</span>
      </div>
      <div class="iplist" id="iplist">
        <ul class="iplist_list" v-for="(item) in iplist_arr" :key="item">
          <li class="ipNum_test list_quan ipNum ipNum1" @click="edit($event)">{{item[0]}}</li>
          <li class="ip_dian ipNum">.</li>
          <li class="ipNum_test list_quan ipNum ipNum2" @click="edit($event)">{{item[1]}}</li>
          <li class="ip_dian ipNum">.</li>
          <li class="ipNum_test list_quan ipNum ipNum2" @click="edit($event)">{{item[2]}}</li>
          <li class="ip_dian ipNum">.</li>
          <li class="ipNum_test list_quan ipNum ipNum3" @click="edit($event)">{{item[3]}}</li>
          <li class="list_quan1">
            <el-button
              style="padding:4px;width:22px"
              icon="el-icon-minus"
              size="mini"
              @click="removeIp($event)"
              circle
            ></el-button>
          </li>
        </ul>
      </div>
      <!-- <div>
        <el-button icon="el-icon-plus" size="mini" @click="addIp" circle style="margin-top:20px;"></el-button>
      </div>-->
      <p v-if="ip_show" class="warning">您输入的IP格式不正确,请重新输入</p>
    </div>
  </el-dialog>
</template>

<script>
import { setAdmin, getRole, getUser } from "../../../api/index";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
        callback(new Error("请输入正确手机号"));
      } else {
        callback();
      }
    };
    return {
      form: {
        limit: "不启用"
      },
      options: {},
      outerVisible: false,
      rules: {
        name: [{ validator: validatePass, trigger: "blur" }]
      },
      iplist_arr: [],
      iplist: [],
      limit: 0,
      loginData: {},
      ip_show: false
    };
  },
  mounted() {
    this.getRoleFun();
  },
  methods: {
    init(id, data) {
      this.outerVisible = true;
      let data_new = {
        userId: data.userId
      };
      getUser(data_new)
        .then(res => {
          this.form = res.data;
          if (res.data.limit == 1) {
            this.form.limit = "启用";
          } else {
            this.form.limit = "不启用";
          }
          this.form.ipList.forEach(element => {
            element.split("\\.");

            let list_obj = Object.assign({}, element.split("."));
            this.iplist_arr.push(list_obj); //编辑时查看新的ip数组
            console.log(this.iplist_arr);
          });
        })
        .catch(error => {});
    },
    // 点击删除该IP地址
    removeIp(e) {
      e.currentTarget.parentNode.parentNode.remove();
    },
    // 添加一条IP地址
    addIp() {
      this.iplist_arr.push({
        num1: "",
        num2: "",
        num3: "",
        num4: ""
      });
    },
    // 提交
    commitset() {
      // 判断获取ip
      if (this.form.limit == "启用") {
        this.limit = 1;
        var iplist_list = document.getElementsByClassName("iplist_list");
        if (iplist_list.length >= 1) {
          this.iplist = [];
          for (let index = 0; index < iplist_list.length; index++) {
            let ipNum = iplist_list[index].getElementsByClassName("ipNum");
            console.log(ipNum);
            let str = "";
            for (let i = 0; i < ipNum.length; i++) {
              str = str + ipNum[i].innerHTML;
            }
            this.iplist.push(str);
          }
          this.testContent();
          this.iplist_str();
        }
      } else if (this.form.limit == "不启用") {
        this.limit = 0;
        this.iplist = [];
        this.commit();
      }
    },
    // 检测内容
    testContent() {
      console.log("abcdefg");
      var a = [];
      var all_ipNum = document.getElementsByClassName("ipNum_test");
      for (let k = 0; k < all_ipNum.length; k++) {
        var reg = /^[1-9]\d*$|^0$/;
        if (reg.test(all_ipNum[k].innerHTML) == true) {
          a.push("true");
          all_ipNum[k].style.color = "#323232";
        } else {
          a.push("false");
          all_ipNum[k].style.color = "red";
        }
      }
      console.log(a);
      if (a.indexOf("false") == -1) {
        this.ip_show = false;
        this.commit();
      } else {
        this.ip_show = true;
      }
    },
    commit() {
      let data = {
        ipList: this.iplist,
        limit: this.limit,
        mobile: this.form.mobile,
        roleId: this.form.roleId,
        userId: this.form.userId
      };
      console.log(data);
      setAdmin(data)
        .then(res => {
          this.$emit("setuser");
          this.$message({
            message: "修改成功",
            type: "success"
          });
          this.outerVisible = false;
        })
        .catch(error => {
          this.$message.error(error.msg);
        });
    },
    // 转换ip格式
    iplist_str() {
      console.log(this.iplist);
      for (let i = 0; i < this.iplist.length; i++) {
        // this.iplist_arr.push(this.iplist[i].split("."));
        var arr = this.iplist[i].split(".");
        let obj = {
          num1: arr[0],
          num2: arr[1],
          num3: arr[2],
          num4: arr[3]
        };
      }
    },
    offDialog() {
      this.form.roleId = null;
      this.iplist_arr = [];
      this.ip_show = false;
      this.$refs["forms"].resetFields();
    },
    getRoleFun() {
      getRole()
        .then(res => {
          this.options = res.data;
        })
        .catch(error => {});
    },
    // 点击修改ip地址
    edit(element) {
      if (this.titleEditing) {
        return;
      }
      this.titleEditing = true;
      let old = element.target.innerHTML;
      element.target.innerHTML = "";
      var newObj = document.createElement("input");
      newObj.value = old;
      element.target.appendChild(newObj);
      newObj.style.width = "100%";
      newObj.style.height = "100%";
      newObj.style.padding = "0";
      newObj.style.margin = "0";
      newObj.style.border = "none";
      newObj.style.outline = "none";
      newObj.focus();
      var that = this;
      newObj.onblur = function() {
        element.target.innerHTML = this.value ? this.value : old;
        that.titleEditing = false;
        element.target.style.color = "#323232";
      };
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  .el-dialog__header {
    .el-dialog__title {
      font-size: 14px;
      color: #323232;
    }
    padding: 16px;
    border-bottom: 1px solid #e5e5e5;
  }
  .el-dialog__body {
    padding: 20px 66px;
  }
}
.el-form {
  .phone_input {
    /deep/.el-input__inner {
      border: 0px solid black;
      background-color: #fff;
      color: #606266;
    }
  }
  /deep/.el-form-item__label {
    text-align: right;
  }
}
.iplist_box {
  position: relative;
  text-align: center;
  width: 100%;
  padding-bottom: 20px;
  /* height: 100px; */
  border: 1px solid #e2e2e2;
  .iplist_titile {
    height: 30px;
    margin-top: 20px;
    width: 100%;
    color: #aaaaaa;
  }
  .iplist {
    display: flex;
    flex-direction: column;
    .iplist_list {
      list-style: none;
      flex: 1;
      display: flex;
      flex-direction: row;
      margin-top: 10px;
      padding-left: 20px;
      padding-right: 20px;
      li {
        height: 38px;
        line-height: 38px;
        list-style: none;
        overflow: hidden;
        .inp {
          width: 100%;
          height: 100%;
          padding: 0;
          margin: 0;
          border: none;
          outline: none;
        }
      }
      .list_quan {
        flex: 1;
      }
      .list_quan1 {
        width: 40px;
      }
      .ipNum1 {
        border: 1px solid #e2e2e2;
        border-right: 0px solid #e2e2e2;
      }
      .ipNum2 {
        border: 1px solid #e2e2e2;
        border-left: 0px solid #e2e2e2;
        border-right: 0px solid #e2e2e2;
      }
      .ipNum3 {
        border: 1px solid #e2e2e2;
        border-left: 0px solid #e2e2e2;
      }
      .ip_dian {
        border-top: 1px solid #e2e2e2;
        border-bottom: 1px solid #e2e2e2;
        line-height: 30px;
        display: flex;
        height: 30px;
        text-align: center;
      }
    }
  }
  .warning {
    position: absolute;
    left: 20px;
    bottom: 0px;
    font-size: 12px;
    color: red;
  }
}
</style>